// Íconos propios (24 × 24). Utilitarios de un trazo (PATHS) y principales en dos tonos (DUO).
const PATHS = {
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6 6 18',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6 7 7M17 17l1.4 1.400M5.6 18.4 7 17M17 7l1.4-1.4',
  moon: 'M20 14.500A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.500Z',
  rows: 'M4 6h16M4 10h16M4 14h16M4 18h16',
  rowsWide: 'M4 7h16M4 12h16M4 17h16',
  check: 'M5 12.5 10 17.5 19.5 7',
  inbox: 'M4 13l2.5-8h11L20 13v6H4zM4 13h5a3 3 0 0 0 6 0h5',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM20 20l-4-4',
  upload: 'M12 16V5m0 0-4 4m4-4 4 4M4 17v3h16v-3',
  arrowUp: 'M12 19V5m0 0-6 6m6-6 6 6',
  arrowDown: 'M12 5v14m0 0-6-6m6 6 6-6',
  minus: 'M6 12h12',
  truck: 'M3 7h11v9H3zM14 10h4l3 3v3h-7z',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
  receipt: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6',
} as const;

/**
 * Íconos principales en dos tonos: un relleno suave (clase "duo", con la opacidad que fije la hoja de estilos)
 * bajo un contorno fino. Son los del menú, los estados vacíos y los encabezados.
 */
const DUO = {
  dashboard: (
    <>
      <rect className="duo" x="3.5" y="3.5" width="7.5" height="9.5" rx="2.2" />
      <rect className="duo" x="13" y="11" width="7.5" height="9.5" rx="2.2" />
      <rect x="3.5" y="3.5" width="7.5" height="9.5" rx="2.2" />
      <rect x="13" y="3.5" width="7.5" height="5" rx="2.2" />
      <rect x="13" y="11" width="7.5" height="9.5" rx="2.2" />
      <rect x="3.5" y="15.5" width="7.5" height="5" rx="2.2" />
    </>
  ),
  warehouse: (
    <>
      <path className="duo" d="M3.5 10 12 4l8.5 6v10.5h-17Z" />
      <path d="M3.5 10 12 4l8.5 6v10.5h-17Z" />
      <path d="M8 20.5v-7h8v7M8 16h8M8 18.3h8" />
    </>
  ),
  warehouseSales: (
    <>
      <path className="duo" d="M6 3.5h9l3 3v14H6Z" />
      <path d="M6 3.5h9l3 3v14H6Z" />
      <path d="M9 9h6M9 12h6M9 15h4" />
    </>
  ),
  inventory: (
    <>
      <path className="duo" d="M12 3.5 20 7.5 12 11.5 4 7.5Z" />
      <path d="M12 3.5 20 7.5v9l-8 4-8-4v-9Z" />
      <path d="M4 7.5l8 4 8-4M12 11.5v9" />
    </>
  ),
  products: (
    <>
      <path className="duo" d="M3.5 12.3V5A1.5 1.5 0 0 1 5 3.5h7.3a1.5 1.5 0 0 1 1.1.4l7.1 7.1a1.5 1.5 0 0 1 0 2.2l-6.9 6.9a1.5 1.5 0 0 1-2.2 0l-7.5-7.500a1.5 1.5 0 0 1-.4-1.100Z" />
      <path d="M3.5 12.3V5A1.5 1.5 0 0 1 5 3.5h7.3a1.5 1.5 0 0 1 1.1.4l7.1 7.1a1.5 1.5 0 0 1 0 2.2l-6.9 6.9a1.5 1.5 0 0 1-2.2 0l-7.5-7.500a1.5 1.5 0 0 1-.4-1.100Z" />
      <circle cx="8.2" cy="8.2" r="1.5" />
    </>
  ),
  stores: (
    <>
      <path className="duo" d="M3.5 9 5 4.500h14L20.5 9a2.8 2.8 0 0 1-5.6 0 2.9 2.9 0 0 1-5.8 0 2.8 2.8 0 0 1-5.6 0Z" />
      <path d="M3.5 9 5 4.500h14L20.5 9a2.8 2.8 0 0 1-5.6 0 2.9 2.9 0 0 1-5.8 0 2.8 2.8 0 0 1-5.6 0Z" />
      <path d="M5 11.500V19A1.5 1.5 0 0 0 6.5 20.500h11A1.5 1.5 0 0 0 19 19v-7.500M10 20.500v-5h4v5" />
    </>
  ),
  audit: (
    <>
      <rect className="duo" x="5" y="4.5" width="14" height="16" rx="2.5" />
      <rect x="5" y="4.5" width="14" height="16" rx="2.5" />
      <path d="M9 4.500A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.500V6.500H9ZM9 13.300l2.2 2.2 4-4.4" />
    </>
  ),
  movements: (
    <>
      <rect className="duo" x="3.5" y="3.5" width="17" height="17" rx="4.5" />
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
      <path d="M7.5 9.500h9m0 0-2.6-2.600M16.5 14.500h-9m0 0 2.6 2.6" />
    </>
  ),
  config: (
    <>
      <circle className="duo" cx="15" cy="7" r="2.2" />
      <circle className="duo" cx="9" cy="12" r="2.2" />
      <circle className="duo" cx="16" cy="17" r="2.2" />
      <path d="M4 7h8.800M17.2 7H20M4 12h2.800M11.2 12H20M4 17h9.800M18.2 17H20" />
      <circle cx="15" cy="7" r="2.2" />
      <circle cx="9" cy="12" r="2.2" />
      <circle cx="16" cy="17" r="2.2" />
    </>
  ),
  pos: (
    <>
      <path className="duo" d="M5.5 8.500h13l1 10.400a1.5 1.5 0 0 1-1.5 1.600H6a1.5 1.5 0 0 1-1.5-1.600Z" />
      <path d="M5.5 8.500h13l1 10.400a1.5 1.5 0 0 1-1.5 1.600H6a1.5 1.5 0 0 1-1.5-1.600Z" />
      <path d="M9 11V7a3 3 0 0 1 6 0v4" />
    </>
  ),
  reports: (
    <>
      <rect className="duo" x="4" y="3" width="16" height="18" rx="2.5" />
      <rect x="4" y="3" width="16" height="18" rx="2.5" />
      <path d="M8 16.5v-3M12 16.5v-6M16 16.5v-4.5" />
    </>
  ),
  cleanup: (
    <>
      <path className="duo" d="M4.5 8.5h15v10a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2Z" />
      <path d="M4.5 8.5h15v10a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2Z" />
      <rect x="2.5" y="3.5" width="19" height="5" rx="1.2" />
      <path d="M10 13h4" />
    </>
  ),
  credits: (
    <>
      <rect className="duo" x="2.5" y="5.5" width="19" height="13" rx="2.5" />
      <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
      <path d="M2.5 10h19M6 14.5h4" />
    </>
  ),
  supply: (
    <>
      <rect className="duo" x="7" y="2.5" width="10" height="19" rx="5" />
      <rect x="7" y="2.5" width="10" height="19" rx="5" />
      <circle cx="12" cy="7.5" r="1.8" />
      <circle cx="12" cy="12" r="1.8" />
      <circle cx="12" cy="16.5" r="1.8" />
    </>
  ),
  purchaseRequests: (
    <>
      <path className="duo" d="M5 5.5h11l3 3.5v9.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z" />
      <path d="M5 5.5h11l3 3.5v9.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z" />
      <path d="M11 10.5v6M8 13.5h6" />
    </>
  ),
  purchaseAuth: (
    <>
      <rect className="duo" x="4" y="3.5" width="16" height="17" rx="2.5" />
      <rect x="4" y="3.5" width="16" height="17" rx="2.5" />
      <path d="M8 12.2l2.6 2.6L16 9.4" />
    </>
  ),
  cash: (
    <>
      <rect className="duo" x="3.5" y="6.5" width="17" height="11" rx="2.5" />
      <rect x="3.5" y="6.5" width="17" height="11" rx="2.5" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M6.5 9.500v5M17.5 9.500v5" />
    </>
  ),
  receiveStore: (
    <>
      <path className="duo" d="M4 14.500h16V18a2.5 2.5 0 0 1-2.5 2.500h-11A2.5 2.5 0 0 1 4 18Z" />
      <path d="M4 14.500V18a2.5 2.5 0 0 0 2.5 2.500h11A2.5 2.5 0 0 0 20 18v-3.5" />
      <path d="M12 3.500v11m0 0-3.6-3.600M12 14.500l3.6-3.6" />
    </>
  ),
  masterEntry: (
    <>
      <rect className="duo" x="3.5" y="3.5" width="17" height="17" rx="4.5" />
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
      <path d="M12 8v8M8 12h8" />
    </>
  ),
  masterDispatch: (
    <>
      <rect className="duo" x="2.5" y="6.5" width="11.5" height="9.5" rx="1.6" />
      <rect x="2.5" y="6.5" width="11.5" height="9.5" rx="1.6" />
      <path d="M14 9.500h3.500l3 3.300V16H14Z" />
      <circle cx="7" cy="17.5" r="1.9" />
      <circle cx="17.3" cy="17.5" r="1.9" />
    </>
  ),
} as const;

export type IconName = keyof typeof PATHS | keyof typeof DUO;

export function Icon({ name, size = 18, className }: { name: IconName; size?: number; className?: string }) {
  const duo = name in DUO;
  return (
    <svg className={['icon', duo ? 'icon-duo' : '', className ?? ''].filter(Boolean).join(' ')} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={duo ? 1.5 : 1.7} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {duo ? DUO[name as keyof typeof DUO] : <path d={PATHS[name as keyof typeof PATHS]} />}
    </svg>
  );
}
